<template>
  <div class="renewal-ratio">
    <headBox title="续期继续率统计" class="headerBox"> </headBox>
    <div class="top-info">
      <div class="top-info-item">
        <div class="text1">
          <img src="@/static/images/xqjxl.png" alt="" />
          <span>续期数据依赖保司数据同步，可能存在延迟情况</span>
          <span class="text2" @click="noticeRule">查看续期结算规则 ></span>
        </div>
      </div>
    </div>
    <div class="header">
      <topSearchForm @search="pageChange(1)" @export="exportPolicyExcel" :hiddenExport="false">
        <el-form :inline="true">
          <el-form-item label="应续费周期" prop="pass" class="item">
            <el-date-picker v-model="needPayDate" value-format="yyyy-MM" type="month" placeholder="请选择" style="width:100%"> </el-date-picker>
          </el-form-item>

          <el-form-item label="续费期数" prop="pass" class="item">
            <el-select v-model="payNum" placeholder="请选择" clearable>
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="结算状态" prop="pass" class="item">
            <el-select v-model="balanceStatus" placeholder="请选择" clearable>
              <el-option v-for="item in optionsState" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="产品名称" prop="pass" class="item">
            <el-input v-model="productName" clearable placeholder="请输入" style="width:100%"></el-input>
          </el-form-item>

          <el-form-item label="是否达标" prop="pass" class="item">
            <el-radio-group v-model="isReachStandard" @change="pageChange(1)" style="width:100%">
              <el-radio :label="2">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </topSearchForm>
    </div>
    <div class="body">
      <el-table :data="tableData" border class="omtable" style="width: 100%" tooltip-effect="dark" v-loading="loading">
        <emptyBox slot="empty"></emptyBox>
        <el-table-column prop="needPayDate" label="续费周期-续费期数" min-width="140px" width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.needPayDate.replace(/-/g, '/') }} -
            {{ scope.row.payNum }}
          </template>
        </el-table-column>
        <el-table-column prop="policyNum" label="保单数" min-width="100px" :show-overflow-tooltip="true"></el-table-column>
        <!-- settlementFee -->
        <el-table-column prop="payNum" label="结算应收保费/结算实收保费" min-width="200px" :show-overflow-tooltip="true">
          <template slot-scope="scope"> {{ scope.row.settlementFee }} / {{ scope.row.settlementPayFee }} </template>
        </el-table-column>
        <el-table-column prop="renewalRateStr" label="继续率" min-width="100px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="isReachStandard" label="是否达标" min-width="100px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.isReachStandard == 1" class="whether standard standard1">是</span>
            <span v-else class="whether standard standard2"> 否 </span>
          </template>
        </el-table-column>
        <el-table-column prop="isSure" label="是否确认" min-width="100px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.isSure == 1" class="whether notarize standard1">已确认</span>
            <span v-else class="whether notarize standard2"> 未确认 </span>
          </template>
          <template slot="header">
            <div class="hint">
              <label>是否确认</label>

              <el-tooltip class="item" effect="dark" content="财务是否确认此继续率" placement="top-end">
                <span class="wenhao">?</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="configName" min-width="140px" :show-overflow-tooltip="true">
          <template slot="header">
            <div class="hint">
              <label>续期规则</label>
              <el-popover placement="left" trigger="hover">
                <div style="width: 1000px" class="hint">
                  <el-table :data="continuationRate" :header-cell-style="returnStyle" :span-method="objectSpanMethod" border>
                    <el-table-column property="product" label="产品区分" align="center"></el-table-column>
                    <el-table-column property="time" label="续期时间" align="center"></el-table-column>
                    <el-table-column property="rate" label="继续率要求" align="center"></el-table-column>
                    <el-table-column property="money" label="续期服务费发放比例" align="center"></el-table-column>
                    <emptyBox slot="empty"></emptyBox>
                  </el-table>
                </div>
                <span slot="reference" class="wenhao">?</span>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="renewalRateStandardStr" label="继续率要求" min-width="100" key="renewalRateStandardStr" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.renewalRateStandardStr }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="balanceDate" label="结算日期" min-width="110" key="balanceDate" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.balanceDate.replace(/-/g, '/') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="balanceStatus" label="结算状态" min-width="120" key="balanceStatus" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{
              scope.row.balanceStatus == -1 ? '不符合结算条件' : scope.row.balanceStatus == 0 ? '未结算' : scope.row.balanceStatus == 1 ? '已结算' : '结算中'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150px" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button-group>
              <el-button
                type="warning"
                size="small"
                @click="openDetail(scope.row)"
                >详情</el-button
              > 
            </el-button-group>-->
            <span @click="openDetail(scope.row)" class="particulars">详情</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="page"
        background
        layout="total,prev, pager, next"
        @current-change="pageChange"
        :current-page.sync="pageNum"
        :page-size="10"
        :total="listCount"
      >
      </el-pagination>
    </div>

    <renewalRatioDetails ref="renewalRatioDetails"></renewalRatioDetails>
    <xfdExplainModal ref="xfdExplainModal"></xfdExplainModal>
  </div>
</template>
<script>
import common from '@/api/common.js';
import { ruleTool } from '@/api/mixins';
import renewalRatioDetails from './renewalRatioDetails';
import xfdExplainModal from '@/pages/order/components/xfdExplainModal';
import headBox from '@/components/head.vue';
import topSearchForm from '@/components/topSearchForm';

//当前实例组件
export default {
  mixins: [ruleTool],
  data: () => ({
    continuationRate: [
      // {
      //   product: "特殊产品（详见附表1）",
      //   time: "第13J（同第25J）",
      //   rate: "产品继续率≥95%",
      //   money: "发放100%续期服务费",
      // },
      // {
      //   rate: "90%≤产品继续率＜95%",
      //   money: "发放85%续期服务费",
      // },
      {
        product: '特殊产品（详见续期结算规则附表一）',
        time: '第13J（同第25J）',
        rate: '产品继续率>=90%',
        money: '发放100%续期服务费'
      },
      {
        rate: '85%≤产品继续率＜90%',
        money: '发放90%续期服务费'
      },
      {
        rate: '80%≤产品继续率＜85%',
        money: '发放80%续期服务费'
      },
      {
        product: '特殊产品（信泰所有产品）',
        time: '第13J（同第25J）',
        rate: '整体继续率≥95%',
        money: '发放100%续期服务费'
      },
      {
        rate: '90%≤整体继续率＜95%',
        money: '发放85%续期服务费'
      },
      {
        product: '特殊产品（招商信诺所有产品）',
        time: '第13J（同第25J）',
        rate: '无继续率要求',
        money: '发放100%续期服务费'
      },
      {
        product: '常规产品（除特殊产品外按渠道整体计算）',
        time: '第13J',
        rate: '渠道整体继续率≥92%',
        money: '发放100%续期服务费'
      },
      {
        time: '第25J',
        rate: '渠道整体继续率≥90%',
        money: '发放100%续期服务费'
      },
      {
        time: '第37J',
        rate: '渠道整体继续率≥90%',
        money: '发放100%续期服务费'
      },
      {
        time: '第49J',
        rate: '渠道整体继续率≥90%',
        money: '发放100%续期服务费'
      }
    ],

    userInfo: {},
    needPayDate: '',
    payNum: '',
    balanceStatus: '',
    productName: '',
    isReachStandard: 2,
    tableData: [],
    listCount: 0,
    pageNum: 1,
    form: {},
    detailRow: null,
    options: [
      {
        value: '2',
        label: '2'
      },
      {
        value: '3',
        label: '3'
      },
      {
        value: '4',
        label: '4'
      },
      {
        value: '5',
        label: '5'
      }
    ],
    optionsState: [
      {
        value: '-1',
        label: '不符合结算条件'
      },
      {
        value: '0',
        label: '未结算'
      },
      {
        value: '1',
        label: '已结算'
      }
    ],
    loading: false,
    params: {}
  }),
  components: { renewalRatioDetails, xfdExplainModal, headBox, topSearchForm },
  created() {
    this.getList();
  },
  mounted() {
    this.userInfo = this.$tools.getLocal('userinfo');
  },
  methods: {
    returnStyle() {
      return { background: '#F7F7F7', 'text-align': 'center' };
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        var condition = [1, 2, 4, 7, 8, 9];
        if (rowIndex == 0) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else if (rowIndex == 3) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else if (rowIndex == 6) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else if (condition.includes(rowIndex)) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else if (columnIndex === 1) {
        var condition = [1, 2, 4];
        if (rowIndex == 0) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else if (rowIndex == 3) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else if (condition.includes(rowIndex)) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    openDetail(row) {
      this.detailRow = row;
      this.$refs.renewalRatioDetails.viewVisible = true;
      this.$refs.renewalRatioDetails.searchParams.pageNum = 1;
      this.$refs.renewalRatioDetails.getList();
    },
    pageChange(page) {
      this.pageNum = page;
      this.getList();
    },
    getList() {
      this.params = {
        pageNum: this.pageNum,
        pageSize: 10,
        needPayDate: this.needPayDate ? this.needPayDate : undefined,
        payNum: this.payNum ? this.payNum : undefined,
        balanceStatus: this.balanceStatus ? this.balanceStatus : undefined,
        productName: this.productName,
        isReachStandard: this.isReachStandard === 1 ? '1' : this.isReachStandard === 0 ? '0' : undefined
      };
      this.loading = true;
      this.$http({
        url: '/master/policy/queryRenewalRateList',
        type: 'put',
        params: this.params
      }).then(data => {
        this.loading = false;
        this.tableData = data.data;
        this.listCount = data.total;
      });
    },
    //导出excel
    exportPolicyExcel() {
      var str = '';
      if (this.needPayDate) {
        str += `needPayDate=${this.needPayDate}&`;
      }
      if (this.payNum) {
        str += `payNum=${this.payNum}&`;
      }
      if (this.balanceStatus) {
        str += `balanceStatus=${this.balanceStatus}&`;
      }
      if (this.productName) {
        str += `productName=${this.productName}&`;
      }
      if (this.isReachStandard == 0 || this.isReachStandard == 1) {
        str += `isReachStandard=${this.isReachStandard}`;
      }

      var url = '/master/policy/exportRenewalRateList?' + str;
      this.$tools.daochu(url);
    },
    noticeRule() {
      this.$refs.xfdExplainModal.open();
      this.$refs.xfdExplainModal.mechanUserType = this.userInfo.mechanUserType;
    }
  }
};
</script>
<style lang="scss" scoped>
@import './renewalRatio';
</style>
